import { LanguageApi } from 'src/api';
import { DetailedSourceLanguageResponse } from 'src/api/language/types';
import { ROUTES } from 'src/constants/routes.const';

export const extractLanguagePairIdFromUrl = (url: string): number | null => {
  const match = url.match(/[?&]languagePairId=(\d+)/);
  return match ? +match[1] : null;
};

export const isWordlistUrl = (url: string | undefined): boolean => {
  return !!url && url.includes(ROUTES.wordlists.details);
};

export const getLanguagePairFromUrl = async (
  url: string,
): Promise<DetailedSourceLanguageResponse | null> => {
  const languagePairId = extractLanguagePairIdFromUrl(url);
  if (!languagePairId) return null;

  try {
    const allPairs = await LanguageApi.getAllLanguagePairs();
    return allPairs.find(pair => pair.languagePairId === languagePairId) || null;
  } catch {
    return null;
  }
};
